import {
  CategoriesServicesObjectData,
  SectionOrServiceForTable
} from '../../../types/Admin/CategoriesTopicsTypes';
import { findSectionOrServiceRowById } from './findSectionOrServiceRowById';
import { parseChildrenIconSettings } from './parseChildrenIconSettings';

export const resolveChildrenIconSettingsForEdit = (
  modalData: SectionOrServiceForTable | null | undefined,
  tableData: CategoriesServicesObjectData | undefined,
  kind: 'section' | 'service'
) => {
  if (!modalData?.id) {
    return parseChildrenIconSettings(null);
  }

  const fromModal = parseChildrenIconSettings(modalData);
  if (fromModal.iconUrl) {
    return fromModal;
  }

  if (!tableData) {
    return fromModal;
  }

  if (kind === 'service') {
    const fromServices = tableData.services?.find((row) => row.id === modalData.id);
    if (fromServices?.childrenIconUrl) {
      return parseChildrenIconSettings(fromServices);
    }
  } else {
    const fromSections = tableData.sections?.find((row) => row.id === modalData.id);
    if (fromSections?.childrenIconUrl) {
      return parseChildrenIconSettings(fromSections);
    }
  }

  const fromAll = findSectionOrServiceRowById(tableData.all, modalData.id);
  if (fromAll?.childrenIconUrl) {
    return parseChildrenIconSettings(fromAll);
  }

  return fromModal;
};
